<template>
    <div class="page">
        <div class="left">
            <div v-if="step === 1" class="box">
                <!-- 登录面板 -->
                <div class="title">欢迎来到梦饷云</div>
                <div class="tab">
                    <div
                        class="tab-item"
                        :class="{ actived: loginType === 'account' }"
                        @click="onSwitch('account')"
                    >
                        密码登录
                    </div>
                    <div
                        class="tab-item"
                        :class="{ actived: loginType === 'phone' }"
                        @click="onSwitch('phone')"
                    >
                        短信验证码登录
                    </div>
                </div>
                <!-- 账号密码登录 -->
                <Account v-if="loginType === 'account'" ref="account" />
                <!-- 手机号登录 -->
                <Phone v-if="loginType === 'phone'" ref="phone" />
                <div v-if="loginType === 'account'" class="block">
                    <el-checkbox v-model="isCacheAccount"
                        >记住账号密码</el-checkbox
                    >
                </div>
                <el-button class="btn" :loading="isLoading" @click="onLogin"
                    >登录</el-button
                >
                <div class="register">
                    <span>还没有账号？</span>
                    <span class="tips" @click="onSwitchRegister">免费注册</span>
                </div>
            </div>
            <!-- 选择租户 -->
            <role-select
                v-if="step === 2"
                :tenantList="tenantList"
                :step.sync="step"
                @on-login="handleRoleSelectCb"
            />
        </div>
        <div class="right">
            <img
                src="http://akc-file-upload.oss-cn-shanghai.aliyuncs.com/saas/7a20923747a62d92150451f70edb2c8ecb542a46_1617962412310_9.png"
                alt=""
                class="bg"
            />
            <div class="copyright">
                <div>©2017-2019上海众旦信息科技有限公司 |</div>
                <div>沪公网安备31011502007771号| 沪ICP备17055106号</div>
            </div>
        </div>
        <!-- 选择租户版本 -->
        <version-select
            v-if="isShouldSelectTenant"
            :initData="versionList"
            @on-success="handleVersionSelectSuccess"
        />
    </div>
</template>
<script>
import {
    ApiGetSelectedVersion,
    ApiGetVersionList,
    ApiLoginByGraphCodeAccount,
    ApiLoginByPhone,
    ApiLoginBySecret
} from '@/common/api';
import { Account, Phone, RoleSelect } from './components';
import actions from '@/common/store';
import VersionSelect from '@/components/version-select';
import { mapGetters } from 'vuex';
export default {
    name: 'Login',
    components: {
        Account,
        Phone,
        RoleSelect,
        VersionSelect
    },
    data() {
        return {
            isLoading: false,
            loginType: 'account', // account 账号登录/ phone 手机号登录
            isCacheAccount: false,
            versionList: [],
            step: 1,
            tenantList: [], // 当前用户的租户类型列表
            tmpToken: '', // 当前用户临时token，用户盘点需不需要跳转到租户选择界面
            isShouldSelectTenant: false, // 是否需要显示选择版本的弹窗
            tenantType: '' // 当前的租户类型
        };
    },
    created() {
        const { versionId, tenantType } = this.userInfo;
        // tenantType 为 2 是梦饷云租户，需要手动选择版本
        if (tenantType === 2 && (!versionId || versionId === '0')) {
            this.getVersionList();
        }
        // 自动登录
        let accountInfo =
            window.localStorage.getItem('accountInfo') || undefined;
        accountInfo = accountInfo && JSON.parse(accountInfo);
        if (accountInfo && accountInfo.userName && accountInfo.password) {
            this.isCacheAccount = true;
        }
        const secret = this.$route.query.secret;
        if (secret) {
            this.loginBySecret(secret);
        }
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    methods: {
        onSwitch(type) {
            this.loginType = type;
        },
        // 缓存用户信息
        setUserInfo(data) {
            this.$store.dispatch('set_token', data.token);
            const { tenantList, tmpToken, tenantType } = data;
            this.tenantType = tenantType;
            // 如果有tmpToken的话，需要先进入到选择租户的流程
            if (tmpToken) {
                this.tenantList = tenantList;
                this.tmpToken = tmpToken;
            } else {
                // 设置预制属性
                this.$analysys.registerSuperProperties({
                    application_name:
                        data.tenantType === 3 ? '阿基米德' : '梦饷云'
                });
                // 上报用户的浏览器信息
                this.$analysys.track('$startup', {});
            }
        },
        // 查询用户是否选择了版本
        getSelectedVersion(userInfo) {
            const { tenantType } = userInfo;
            // 登录成功之后，如果用户没有选择过版本，则跳出选择版本弹窗
            // 只在用户类型为梦饷云用户(tenantType === 2)的情况下弹出
            // 其他情况直接跳转
            // 6, "供应链开放-经销"、7, "供应链开放-代销
            if ([2, 5, 6, 7, 8, 9].includes(tenantType)) {
                ApiGetSelectedVersion().then(res => {
                    const data = (res && res.data) || {};
                    if (!data.versionId || data.versionId === '0') {
                        this.getVersionList();
                    } else {
                        this.pageTo();
                    }
                });
            } else {
                this.pageTo();
            }
        },
        // 版本选择成功
        handleVersionSelectSuccess() {
            if (this.tmpToken) {
                this.step = 2;
            } else {
                this.pageTo();
            }
        },
        // 查询版本列表
        getVersionList() {
            ApiGetVersionList().then(res => {
                const data = (res && res.data) || {};
                this.isShouldSelectTenant = true;
                this.versionList = data;
            });
        },
        // 登录之后页面跳转
        pageTo() {
            // 梦饷云用户才跳转到小程序创建页
            if (this.tenantType === 2) {
                this.$router.push({
                    path: '/any/merchant/shop/mini-manage'
                });
            } else {
                this.$router.push({
                    path: '/any'
                });
            }
        },
        // 登录之后的流程
        loginAfter(res) {
            const { data, message } = res;
            this.isLoading = false;
            if (data) {
                this.setUserInfo(data);
                this.$message({
                    message: message,
                    duration: 1000,
                    type: 'success'
                });
                // 登录之后，是否需要选择租户
                if (data.tmpToken) {
                    this.step = 2;
                } else {
                    // 查询是否选择过版本
                    this.getSelectedVersion(data);
                }
            } else {
                this.$message({
                    message: '登录出错，请重试！',
                    duration: 2000,
                    type: 'error'
                });
            }
        },
        // 登录
        onLogin() {
            const res = this.$refs[this.loginType].submit();
            if (this.loginType === 'account') {
                if (res.userName && res.password) {
                    this.loginByAccount({
                        userName: res.userName,
                        password: res.password,
                        code: res.code,
                        uuid: res.uuid
                    });
                }
            } else {
                if (res.phone && res.smsCode) {
                    this.loginByPhone({
                        phone: res.phone,
                        smsCode: res.smsCode
                    });
                }
            }
        },
        // 手机号登录
        loginByPhone(obj) {
            if (this.isLoading) return;
            this.isLoading = true;
            ApiLoginByPhone(obj)
                .then(res => {
                    this.loginAfter(res);
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        // 账号密码登录
        loginByAccount(obj) {
            if (this.isLoading) return;
            this.isLoading = true;
            ApiLoginByGraphCodeAccount(obj)
                .then(res => {
                    this.loginAfter(res);
                    // 如果设置了记住密码
                    if (this.isCacheAccount) {
                        const cache = {
                            userName: obj.userName,
                            password: obj.password
                        };
                        cache &&
                            window.localStorage.setItem(
                                'accountInfo',
                                JSON.stringify(cache)
                            );
                    } else {
                        localStorage.removeItem('accountInfo');
                    }
                })
                .catch(() => {
                    // 刷新验证码
                    this.$refs.account.getValidateCode();
                    this.isLoading = false;
                });
        },
        // 密钥登录
        loginBySecret(secret) {
            ApiLoginBySecret({ secret }).then(res => {
                const { data, message } = res;
                if (data) {
                    this.setUserInfo(data);
                    this.$message({
                        message,
                        duration: 1000,
                        type: 'success'
                    });
                    // 登录之后，是否需要选择租户
                    if (data.tmpToken) {
                        this.step = 2;
                    } else {
                        // 查询是否选择过版本
                        this.getSelectedVersion(data);
                    }
                } else {
                    this.$message.error({
                        message: '登录出错，请重试！',
                        duration: 2000
                    });
                }
            });
        },
        // 选择了租户角色之后
        handleRoleSelectCb(obj) {
            obj.tmpToken = this.tmpToken;
            this.loginByPhone(obj);
        },
        onSwitchRegister() {
            this.$router.push({ path: '/register' });
        }
    }
};
</script>
<style lang="scss" scoped>
$baseColor: #f56c6c;
.page {
    min-width: 1100px;
    height: 100%;
    min-height: 768px;
    display: flex;
    .left {
        flex: 1;
        padding: 150px 0;
        .box {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin: 0 auto;
            width: 336px;
        }
        .tips {
            cursor: pointer;
            height: 14px;
            font-size: 14px;
            font-weight: 400;
            color: #0772eb;
            line-height: 14px;
        }
        .title {
            font-size: 34px;
            font-weight: 600;
            color: #242424;
            line-height: 34px;
            margin-bottom: 40px;
        }
        .tab {
            display: flex;
            justify-content: center;
            margin-bottom: 36px;
            .tab-item {
                cursor: pointer;
                &:first-child {
                    margin-right: 34px;
                }
                font-size: 20px;
                font-weight: 400;
                color: #878d99;
                line-height: 20px;
                &.actived {
                    color: $baseColor;
                    position: relative;
                }
                &.actived::after {
                    content: '';
                    width: 100%;
                    position: absolute;
                    height: 2px;
                    border-radius: 1px;
                    background: $baseColor;
                    left: 0;
                    bottom: -10px;
                }
            }
        }
        // 重置样式
        ::v-deep {
            .ant-checkbox-wrapper-checked {
                .ant-checkbox-inner {
                    background-color: $baseColor;
                    border-color: $baseColor;
                }
                .ant-checkbox-checked::after {
                    border-color: $baseColor;
                }
                span {
                    color: $baseColor;
                }
            }
        }
        .block {
            text-align: left;
        }
        .btn {
            cursor: pointer;
            margin-top: 30px;
            background: $baseColor;
            width: 335px;
            height: 48px;
            text-align: center;
            color: #fff;
            border-radius: 4px;
            border: 0;
        }
        .register {
            text-align: right;
            margin-top: 15px;
            font-size: 14px;
            font-weight: 400;
            color: #5a5f66;
            line-height: 14px;
        }
    }
    .right {
        height: 100%;
        position: relative;
        .bg {
            height: 100%;
        }
        .copyright {
            text-align: center;
            width: 280px;
            height: 32px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 16px;
            position: absolute;
            bottom: 18px;
            left: 50%;
            transform: translateX(-50%);
        }
    }
}
</style>
